// import React, { useState } from 'react'
// import { AgGridReact } from 'ag-grid-react'; 
// import "ag-grid-community/styles/ag-grid.css"; 
// import "ag-grid-community/styles/ag-theme-quartz.css"; 
// import { useSelector } from 'react-redux';

// const TableComponent = ({report, meters,parameter}) => {
//   const mode = useSelector((state) => state.darkMode);
//   const { isdarkMode } = mode;
//     console.log(report) 
//     console.log(meters)

//     const [rowData, setRowData] = useState([
//         { make: "Tesla", model: "Model Y", price: 64950, electric: true },
//         { make: "Ford", model: "F-Series", price: 33850, electric: false },
//         { make: "Toyota", model: "Corolla", price: 29600, electric: false },
//       ]);

//     const columns = [{field:'date',pinned: "left", }]
    
//       meters.map((i)=>{
//             columns.push({field:i}) 
//       })
//       console.log(columns)
      
//       // Column Definitions: Defines the columns to be displayed.
//       const [colDefs, setColDefs] = useState([
//         { field: "make" },
//         { field: "model" },
//         { field: "price" },
//         { field: "electric" }
//       ]);


//   return (
//     <div
//         //   style={gridStyle}
//           className={`${isdarkMode ? "ag-theme-quartz-dark": "ag-theme-alpine"}`}
//           style={{ height: 400 }}
//         >
//           <AgGridReact 
//             rowData={report}
//             columnDefs={columns.length>1 ?columns :[]}
//             pagination={true}
//             domLayout="normal" 
//             defaultColDef={{
//               resizable: true,
//             }}
//             rowHeight={50}
//             suppressHorizontalScroll={false} 
//             overlayNoRowsTemplate={`<span style="color: gray; font-size: 16px;">No rows to show</span>`} 
//           />
//         </div>
//   )
// }

// export default TableComponent




import React, { useState, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react'; 
import "ag-grid-community/styles/ag-grid.css"; 
import "ag-grid-community/styles/ag-theme-quartz.css"; 
import { useSelector } from 'react-redux';

const TableComponent = ({ report, meters, parameter }) => {
  const mode = useSelector((state) => state.darkMode);
  const { isdarkMode } = mode;

  const [columns, setColumns] = useState([{ field: "date", pinned: "left" }]);

  useEffect(() => {
    if (meters.length > 0) {
      setColumns([{ field: "date", pinned: "left" }, ...meters.map((i) => ({ field: i }))]);
    }
  }, [meters]);
    const color = useSelector((state) => state.ThemeChange);
      console.log(color)

  return (
    <div className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}  style={{
      '--ag-header-background-color': color.themeConfig.colorPrimary, 
      '--ag-header-foreground-color': '#fff', 
      height: "80vh", width: "100%", overflowY: "auto" 
    }}>
      <AgGridReact 
        rowData={report?.length > 0 ? report : []}
        columnDefs={columns?.length > 1 ? columns : []}
        pagination={true}
        domLayout="normal" 
        defaultColDef={{
          resizable: true,
        }}
        rowHeight={50}
        suppressHorizontalScroll={false}
        overlayNoRowsTemplate={`<span style="color: gray; font-size: 16px;">No rows to show</span>`} 
      />
    </div>
  );
};

export default TableComponent;
